import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { Site } from "../utils/backend-types";

export function useIsMieterstrom(siteId?: number) {
  return useQuery({
    queryKey: ["isMieterstrom", { siteId }],
    queryFn: () => fetchIsMieterstrom(siteId),
    staleTime: Infinity,
    enabled: siteId !== undefined
  });
}

async function fetchIsMieterstrom(siteId?: number) {
  if (siteId === undefined) {
    return false;
  }

  const res = await apiWithoutCamelization.get<Site>(
    urls.apiWithoutCamelization.sitesDetail(siteId)
  );
  return res.data?.is_mieterstrom_site ?? false;
}
